// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 11) return "static/js/50601c27d11e42b60c9a.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"31f879c3ba185004056d","179":"ebc96c8f6f1244832ded","180":"2f83cd9b42fa412cce22"}[chunkId] + ".chunk.js";
};